<ng-container *ngIf="!selectedItemsSize">
  <div class="list-name-container">
    <strong *ngIf="loading">Loading...</strong>
  
    <div class="list-name-input-container" [class.editable]="!listIsDeployed">
      <div class="input-sizer" [class.editable]="!listIsDeployed">
        <input
          #listNameInput
          [class.sm-hidden]="loading"
          type="text"
          rows="1"
          class="list-name"
          [class.editable]="!listIsDeployed"
          [readonly]="listIsDeployed"
          placeholder="Type list name..."
          [value]="list?.name || ''"
          (change)="updateListName($event.target.value)"
          [title]="list?.name || ''"
          (input)="updateInputSize($event.target)"
          (keyup.esc)="onEscapePress()"
        />
      </div>
      <em
        class="edit-icon cc-icon cc-icon-pencil"
        [class.sm-hidden]="loading"
        (click)="listNameInput.focus()"
        title="Edit list name"
      ></em>
    </div>
  </div>
  
  <div class="sm-flex">
    <span class="updating-list" *ngIf="updating">
      <i class="cc-icon cc-icon-spinner-lg"></i>
      <span>Updating...</span>
    </span>
  
    <cc-popover placement="bottom">
      <div class="import-csv-popover" content>
        <p class="title" i18n>Import CSV</p>
        <p class="subtitle" i18n>Excel files (xls, xlsx) are <br />not supported</p>
      </div>
      <button
        trigger
        [disabled]="!canAddNewItem"
        class="control-button"
        (click)="uploadList()"
        data-test="upload-list-button"
      >
        <i class="cc-icon cc-icon-download"></i>
        <span i18n>Import</span>
      </button>
  
      <input
        #fileUploadInput
        type="file"
        name="file"
        data-test="file-upload-input"
        class="sm-hidden"
        (change)="onFileUpload($event.target.files); $event.target.value = null"
        accept="text/csv"
      />
    </cc-popover>
  
    <cc-popover placement="bottom">
      <div class="download-csv-popover" content>
        <p class="title" i18n>Download CSV</p>
      </div>
      <button
        trigger
        [disabled]="!canAddNewItem"
        class="control-button"
        data-test="download-csv-button"
        (click)="downloadList()"
      >
        <i class="cc-icon cc-icon-upload"></i>
        <span i18n>Export</span>
      </button>
    </cc-popover>
  
    <button [disabled]="!canAddNewItem" class="add-item-button" (click)="addListItem()">Add Item</button>
  </div>  
</ng-container>

<div class="multiple-selection-controls" *ngIf="selectedItemsSize">
  <button (click)="onDeleteItems()">
    <i class="cc-icon cc-icon-delete sm-text-default-red"></i>
    <span i18n>Delete</span>
  </button>

  <button (click)="onStartBulkApplyItemColour()" *ngIf="!listIsDeployed">
    <i class="cc-icon cc-icon-pencil sm-text-default-text"></i>
    <span i18n>Apply Colour</span>
  </button>
</div>
